// Quantity Selector - Event delegation globale
// Gère TOUS les quantity selectors (product page + cart drawer dynamique)
// Dépendance: helpers.js (DPC.toast)

/**
 * Met à jour la quantité et l'UI d'un selector
 * @param {HTMLElement} selector - Container [data-quantity-selector]
 * @param {number} newValue - Nouvelle valeur demandée
 * @param {string} source - Source du changement ('button' ou 'input')
 */
function updateQuantity(selector, newValue, source = "button") {
  const input = selector.querySelector("[data-quantity-input]");
  const increaseBtn = selector.querySelector('[data-quantity-btn="increase"]');

  if (!input || !increaseBtn) return;

  // Autoriser 0 pour cart drawer (suppression), sinon min = 1
  const isCartDrawer = selector.dataset.lineIndex !== undefined && selector.dataset.lineIndex !== "";
  const min = isCartDrawer ? 0 : 1;
  const max = input.dataset.max ? parseInt(input.dataset.max) : Infinity;
  const requestedQty = parseInt(newValue) || min;
  const quantity = Math.max(min, Math.min(max, requestedQty));

  // Feedback si dépassement du max
  if (requestedQty > max && max !== Infinity) {
    if (source === "button") {
      DPC.toast(`Stock maximum atteint (${max} disponible${max > 1 ? "s" : ""})`, "warning");
    } else if (source === "input") {
      DPC.toast(`Quantité ajustée : maximum ${max} disponible${max > 1 ? "s" : ""}`, "warning");
    }
  }

  input.value = quantity;

  // Update disabled state (data attribute + classes CSS)
  const isAtMax = quantity >= max;
  increaseBtn.dataset.disabled = isAtMax ? "true" : "false";

  if (isAtMax) {
    increaseBtn.classList.add("opacity-30", "cursor-not-allowed");
    increaseBtn.classList.remove("cursor-pointer", "hover:text-wolf-dark");
  } else {
    increaseBtn.classList.remove("opacity-30", "cursor-not-allowed");
    increaseBtn.classList.add("cursor-pointer", "hover:text-wolf-dark");
  }

  // Emit custom event
  selector.dispatchEvent(
    new CustomEvent("quantity-change", {
      bubbles: true,
      detail: {
        quantity,
        lineIndex: selector.dataset.lineIndex,
      },
    })
  );
}

// Event delegation - Clics sur boutons +/-
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-quantity-btn]");
  if (!btn) return;

  const selector = btn.closest("[data-quantity-selector]");
  const input = selector?.querySelector("[data-quantity-input]");
  if (!selector || !input) return;

  const isIncrease = btn.dataset.quantityBtn === "increase";
  const currentValue = parseInt(input.value) || 1;

  // Empêcher le clic sur bouton + si déjà au max
  if (isIncrease && btn.dataset.disabled === "true") {
    const max = input.dataset.max;
    if (max) {
      DPC.toast(`Stock maximum atteint (${max} disponible${max > 1 ? "s" : ""})`, "warning");
    }
    return;
  }

  // Feedback préventif pour suppression (decrease à quantité 1)
  if (!isIncrease && currentValue === 1 && selector.dataset.lineIndex) {
    DPC.toast("Article supprimé du panier", "info");
  }

  updateQuantity(selector, currentValue + (isIncrease ? 1 : -1), "button");
});

// Event delegation - Changement manuel input
document.addEventListener("change", (e) => {
  const input = e.target.closest("[data-quantity-input]");
  if (!input) return;

  const selector = input.closest("[data-quantity-selector]");
  if (!selector) return;

  updateQuantity(selector, input.value, "input");
});

// Initialiser l'état disabled des boutons + au chargement
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-quantity-selector]").forEach((selector) => {
    const input = selector.querySelector("[data-quantity-input]");
    const increaseBtn = selector.querySelector('[data-quantity-btn="increase"]');

    if (input && increaseBtn) {
      const currentQty = parseInt(input.value) || 1;
      const max = input.dataset.max ? parseInt(input.dataset.max) : Infinity;
      const isAtMax = currentQty >= max;

      increaseBtn.dataset.disabled = isAtMax ? "true" : "false";

      if (isAtMax) {
        increaseBtn.classList.add("opacity-30", "cursor-not-allowed");
        increaseBtn.classList.remove("cursor-pointer", "hover:text-wolf-dark");
      } else {
        increaseBtn.classList.remove("opacity-30", "cursor-not-allowed");
        increaseBtn.classList.add("cursor-pointer", "hover:text-wolf-dark");
      }
    }
  });
});
